import mapboxgl from "mapbox-gl";
import { IconType } from "../../map/icons";
import {
    carLayout,
    trajectoryArrowLayout,
    variableSymbolLayout,
} from "../../map/layers/layouts";
import { tripsSources } from "./sources";

import {
    addLayersIfNotExist,
    genericLineLayer,
    genericPointLayer,
    safeRemoveLayers,
} from "../../map/layers/generics";

import {
    convertBoardingType,
    convertUTCtoJST,
} from "../../../utils/formatting";

export const unladenStartLocLyr: mapboxgl.Layer = {
    id: "naviPathsStartIconLyr",
    source: tripsSources.unladenStartPtSrc,
    type: "symbol",
    layout: carLayout,
};

export const deliverStartLocLyr = genericPointLayer(
    "deliverStartLocLyr",
    tripsSources.deliverStartLocSrc,
    6,
    "color"
);

export const goCancelLocLyr: mapboxgl.Layer = {
    id: "goCancelLocLyr",
    source: tripsSources.goCancelLocSrc,
    type: "symbol",
    layout: variableSymbolLayout(IconType.SQUARE_BLACK),
};

export const naviShapeLyr = genericLineLayer(
    "naviShapeLyr",
    tripsSources.naviShapeSrc,
    18,
    0.7
);

export const naviShapeArrowsLyr: mapboxgl.Layer = {
    id: "naviShapeArrowsLyr",
    source: tripsSources.naviShapeSrc,
    type: "symbol",
    layout: trajectoryArrowLayout,
};

export const unladenShapeLyr = genericLineLayer(
    "unladenShapeLyr",
    tripsSources.unladenShapeSrc,
    5,
    1
);

export const unladenShapeArrowsLyr: mapboxgl.Layer = {
    id: "unladenShapeArrowsLyr",
    source: tripsSources.unladenShapeSrc,
    type: "symbol",
    layout: trajectoryArrowLayout,
};

export const allLayersInOrder = [
    naviShapeLyr,
    naviShapeArrowsLyr,
    unladenShapeLyr,
    unladenShapeArrowsLyr,
    unladenStartLocLyr,
    deliverStartLocLyr,
    goCancelLocLyr,
];

export const addAllLayersInOrder = (map: mapboxgl.Map): void => {
    addLayersIfNotExist(map, allLayersInOrder);
};

export const removeGoCancelsLayers = (map: mapboxgl.Map): void => {
    safeRemoveLayers(map, [goCancelLocLyr]);
};

export const addGoCancelsLayers = (map: mapboxgl.Map): void => {
    addLayersIfNotExist(map, [goCancelLocLyr]);
};

const hoverOwnPickup: any = null;

export const setHighlightsWithPopup = (map: mapboxgl.Map): void => {
    setHighlightWithPopup(
        deliverStartLocLyr.id,
        tripsSources.deliverStartLocSrc,
        map,
        hoverOwnPickup,
        ownPickupTemplate
    );

    setHighlightWithPopup(
        goCancelLocLyr.id,
        tripsSources.goCancelLocSrc,
        map,
        null,
        goCancelTemplate
    );
};

export const setHighlightWithPopup = (
    layerName: string,
    dataSourceName: string,
    map: mapboxgl.Map,
    hoveredItem: any,
    templateMaker: any
): void => {
    let popup;
    map.on("mouseenter", layerName, (e: any) => {
        map.getCanvas().style.cursor = "pointer";
        hoveredItem = e.features[0].id;

        if (hoveredItem) {
            map.setFeatureState(
                { source: dataSourceName, id: hoveredItem },
                { hover: false }
            );

            if (e.features && e.features[0] && e.features[0].properties) {
                popup = new mapboxgl.Popup()
                    .setLngLat(e.lngLat)
                    .setHTML(templateMaker(e.features[0]));
                popup.addTo(map);
            }
        }

        hoveredItem = e.features[0].id;

        (map as mapboxgl.Map).setFeatureState(
            { source: dataSourceName, id: hoveredItem },
            { hover: true }
        );
    });

    map.on("mouseleave", layerName, (e: any) => {
        if (hoveredItem) {
            map.setFeatureState(
                { source: dataSourceName, id: hoveredItem },
                { hover: false }
            );
        }
        map.getCanvas().style.cursor = "initial";
        hoveredItem = null;
        popup.remove();
    });
};

export const ownPickupTemplate = (feature: any): string => {
    const boardingType = feature.properties.boardingType;
    const boardingTs = feature.properties.boardingTs;
    return `
                    <div>
                    <strong>
                    自車両実車地
                    </strong>
                    </div>
                    <div>
                    実車時刻: ${boardingTs}
                    </div>
                    <div>
                    乗車種別: ${convertBoardingType(boardingType)}
                    </div>
                    `;
};

export const goCancelTemplate = (feature: any): string => {
    const cancelTs = feature.properties.goCancelTs;
    return `
                    <div>
                    <strong>
                    GOキャンセル地点
                    </strong>
                    </div>
                    <div>
                    キャンセル時刻 ${convertUTCtoJST(cancelTs)}
                    </div>
                    `;
};
